// Menu Items
export const menuAbout = 'ABOUT';
export const menuSolutions = 'SOLUTIONS';
export const menuArticles = 'RESEARCH';
export const menuNews = 'NEWS';
export const menuContacts = 'CONTACTS';
export const menuRecruit = 'RECRUIT';

// About Submenu
export const aboutStory = '기업소개 (Our Story)';
export const aboutCompetency = '핵심 역량 (Core Competency)';
export const aboutHistory = '회사 연혁 (History)';
export const aboutPeople = '피플 (People)';
export const aboutPartner = '파트너 (Partner)';
export const aboutCI = 'CI';

// Solutions Submenu
export const solutionsHealthcare = '디지털 헬스케어';
export const solutionsSports = '디지털 스포츠';

// Articles Submenu
export const articlesMenu = '논문 및 연구자료';

// News Submenu
export const newsArticles = '기사';
export const newsNotice = '공지사항';
export const newsEvents = 'Events';

// Contacts Submenu
export const contactsMenu = 'Contacts';

// Recruit Submenu
export const recruitSystem = '인사제도';
export const recruitJobs = '채용공고';

export default {
  menuAbout,
  menuSolutions,
  menuArticles,
  menuNews,
  menuContacts,
  menuRecruit,
  aboutStory,
  aboutCompetency,
  aboutHistory,
  aboutPeople,
  aboutPartner,
  aboutCI,
  solutionsHealthcare,
  solutionsSports,
  articlesMenu,
  newsArticles,
  newsNotice,
  newsEvents,
  contactsMenu,
  recruitSystem,
  recruitJobs
};
